export enum FileStatus {
  Set,
  Loading,
  Uploaded,
  Failed,
  InvalidMimeType
}

export type FileData = {
  name?: string
  status: FileStatus
  preview: string | ArrayBuffer | null
  file?: File
  descriptor?: string
  type?: string
}

export enum FileType {
  Image = 'Image',
  Video = 'Video',
  VideoNote = 'VideoNote',
  Animation = 'Animation',
  Voice = 'Voice',
  Audio = 'Audio',
  Document = 'Document',
  MessagePreview = 'MessagePreview',
  TopMessagePreview = 'TopMessagePreview',
  Custom = 'Custom'
}

export type MediaFileData = {
  file: string
  type: FileType
  guid: string
  abstractType: string | null
  blobType: string
  preview: string
  blobFile: File
  name: string
  status: FileStatus
  progress?: number
}
